export default {
  title01: "Vremea actuală",
  title02: "24 de ore",
  title03: "Vedeți prognoza meteo pe 10 zile",
  title04: "Indexul calității aerului",
  title05: "Vezi toate informațiile",
  title06: "RĂSĂRIT ȘI APUS DE SOARE",
  title07: "FAZA LUNII",
  title08: "Următoarea lună plină",
  title09: "Următoarea lună nouă",
  title10: "ZI",
  title11: "NOAPTE",
  title12: "Răsărit",
  title13: "Apus de soare",
  title14: "Răsărit de lună",
  title15: "Apus de Lună",
  title16: "Sursa",
  title17: "Începe",
  title18: "Sfârșit",
  title19: "Utilizați locația curentă",
  title20: "Căutați orașul",
  title21: "Se simte ca",
  title22: "Resimțit la umbră",
  title23: "Acum",
  title24: "Astăzi",
  title25: "DUM",
  title26: "LUN",
  title27: "MAR",
  title28: "MIE",
  title29: "JOI",
  title30: "VIN",
  title31: "SMB",
  title32: "Se încarcă...",
  title33: "Acum",
  title34: "Ore",
  title35: "Zilnic",
  title36: "Soare și lună",
  title37: "Calitatea aerului",
  title38: "Contact la: xlf550402@gmail.com",
  title39: "Acord de confidențialitate",
  title40: "Drepturi de autor © comfortweather.com 2020 - 2026. Toate drepturile rezervate.",
  title41: "Date furnizate de",
  title42: "Hi",
  title43: "Lo",
  title44: "Accept",
  title45:
    "Mulțumim că folosiți ComfortWeather! Pentru a vă proteja mai bine drepturile și interesele legale, vă rugăm să citiți cu atenție ",
  title46: "Politica de Confidențialitate",
  title47: " înainte de utilizare.",
  title48: "",
  title49: "Contact la: xyjph123@gmail.com",
  title50: "Drepturi de autor © 24hweather.com 2020 - 2026. Toate drepturile rezervate.",
  title51:
    "Mulțumim că folosiți 24hweather! Pentru a vă proteja mai bine drepturile și interesele legale, vă rugăm să citiți cu atenție ",
  title52: "Locația dvs. s-a schimbat. Doriți să o actualizați?",
  title53: "Confirmă",
  title54: "Anulează",
  title55: "Înapoi",
  title56: "Știri",
  title57: "Se actualizează vremea...",
  title58: "Vremea a fost actualizată",
  title59: "Vezi tot",
  title60: "Drepturi de autor © mobi321.com 2020 - 2026. Toate drepturile rezervate.",
  title61: "Ieri",
  title62: "Mâine",
  title63: "Vedeți prognoza meteo pe 15 zile",
  title64: "Detaliile de azi",
  title65: "Rahu Kaal",
  title66: "Indici de stil de viață",
  title67: "Indici de stil de viață",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Dificil de uscat",
  title103: "Uscare lentă",
  title104: "Se usucă bine",
  title105: "Uscare rapidă",
  title106: "Uscare foarte rapidă",

  title107: "Nepotrivit",
  title108: "Experiență modestă",
  title109: "Bun pentru distracție la apă",
  title110: "Foarte potrivit",
  title111: "Condiții perfecte",

  title112: "Suportiv pentru sănătate",
  title113: "Condiții neutre",
  title114: "Risc ușor mai mare",
  title115: "Risc mare",
  title116: "În risc extrem",

  title117: "Nepotrivit",
  title118: "Parțial potrivit",
  title119: "Bun pentru activități în aer liber",
  title120: "Foarte potrivit",
  title121: "Condiții excelente",

  title122: "Condiții foarte uscate",
  title123: "Probabil uscat",
  title124: "Ușor uscat",
  title125: "Puțin probabil să fie uscat",
  title126: "Foarte puțin probabil să fie uscat",

  title127: "Nu este recomandat",
  title128: "Acceptabil",
  title129: "Zi bună",
  title130: "Condiții foarte bune",
  title131: "Condiții ideale",
};
